<template>
  <div class="row">
    <div class="col-md-12 show-property">
      <table class="table table-striped table-fixed">
        <tbody v-if="currentLivingCondition !== null">
        <tr>
          <th colspan="4">
            Inwonend
          </th>
        </tr>
        <tr>
          <th>Kosten inwonend p/m</th>
          <td>{{ currentLivingCondition.rental_costs | toCurrency }}</td>
          <th>Overige kosten p/m</th>
          <td>{{ currentLivingCondition.other_costs | toCurrency }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import customerCurrentLivingConditionApi from '~/api/customer_current_living_condition';

export default {
  name: "ShowResidentComponent",
  components: {},
  props: {
    currentLivingConditionId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      currentLivingCondition: null,
    }
  },
  computed: {},
  mounted() {
    customerCurrentLivingConditionApi.getById(this.currentLivingConditionId, ['customer_property', 'customer_property.customer', 'customer_property.property', 'customer_property.property.country']).then(response => {
      this.currentLivingCondition = response.data;
    });
  },
  methods: {},
}
</script>
<style scoped>
</style>
